/* eslint-disable no-console */
import useCompanyStore from '../../../store/companyStore/companyDetailsStore';
import {
  matchesId,
  matchesSubCategory
} from '../../../utils/companyCategorySubCategory';
import {hasAccessToReport} from '../../../utils/SubscriptionHelper';

import {
  CBAM_IRON_AND_STEEL_FOR_ALL_SUBCATEGORIES
} from './cbam/cbamSubCategoryOverride';
import {frameworkRoute} from './frameworkRoutes';
import {FrameworkObj} from './FrameWorksConst';
import {CBAMObject, CBAMObjectIronAndSteel, SASBObject} from './PillarsConst';

export const addPillarsToFrameworkObj: (pillarData: any[]) => any[] = (
  pillarData
) => {
  const companyDetails = useCompanyStore?.getState().companyDetails;

  return FrameworkObj.filter((item) => {
    return handleIsComingSoonConditionally(
      item?.route as frameworkRoute,
      item?.isComingSoon
    )
      ? false
      : hasAccessToReport(item?.route);
  }).map((item) => {
    const pillars = pillarData?.find((PItem: any) => {
      return item?.title?.toLowerCase() === PItem?.name?.toLowerCase();
    })?.pillars;

    return {
      ...item,
      pillars: pillars ?? [],
      timeline: item?.timeline
        ?.filter((item: any) => {
          return item?.category
            ? matchesId(companyDetails?.category, item?.category)
            : true;
        })
        .map((item) => {
          return {
            ...item,
            pillars: pillars?.find((PItem: any) => {
              return PItem?.name === item?.ptitle;
            })
          };
        })
    };
  });
};

export const filterPillarsData: (
  pillarData: any[],
  framework: string,
  pillar: string
) => any = (pillarData, framework, pillar) => {
  return FrameworkObj.filter((item) => {
    return handleIsComingSoonConditionally(
      item?.route as frameworkRoute,
      item?.isComingSoon
    )
      ? false
      : hasAccessToReport(item?.route) && item?.route === framework;
  })
    .flatMap((item) => {
      const pillars = pillarData?.find((PItem: any) => {
        return item?.title?.toLowerCase() === PItem?.name?.toLowerCase();
      })?.pillars;

      return item?.timeline?.map((item) => {
        return {
          ...item,
          pillars: pillars?.find((PItem: any) => {
            return PItem?.name === item?.ptitle;
          })
        };
      });
    })
    .find((fItem: any) => {
      const route = fItem?.routes.split('/')?.[1] ?? '';

      return route === pillar;
    })?.pillars;
};

export const filterFrameworkPillars: (
  pillarData: any[],
  framework: string | undefined
) => any = (pillarData, framework) => {
  const frameworkObjTitle = FrameworkObj?.find((item) => {
    return item?.route === framework;
  })?.title;

  return pillarData?.find((pillar) => pillar?.name === frameworkObjTitle)
    ?.pillars;
};

export const calculateSum = (value: any[]): number | string => {
  return value?.reduce((accumulator, currentValue) => {
    return accumulator + currentValue;
  }, 0);
};

export const sortFrameworkByIsComingSoonAndHideUnauthorizedReports = (
  obj: any[]
): any[] => {
  return obj.sort((a, b) => {
    const aComingSoon = a.isComingSoon === true;
    const bComingSoon = b.isComingSoon === true;

    if (!aComingSoon && bComingSoon) return -1;
    if (aComingSoon && !bComingSoon) return 1;

    return 0;
  });
};

export const handleIsComingSoonConditionally = (
  framework: frameworkRoute | undefined,
  isComingSoon: boolean | undefined
): boolean | undefined => {
  const companyData = useCompanyStore.getState().companyDetails;

  switch (framework) {
    case frameworkRoute.SASB:
      return !SASBObject?.some((item) => {
        return matchesId(companyData?.category, item?.category);
      });
    case frameworkRoute.CBAM:
      if (CBAM_IRON_AND_STEEL_FOR_ALL_SUBCATEGORIES) {
        return false;
      }

      return ![...(CBAMObject || []), ...(CBAMObjectIronAndSteel || [])]?.some(
        (item) => {
          return matchesSubCategory(companyData?.subCategory, item?.subCategory);
        }
      );
    default:
      return isComingSoon;
  }
};

export const sortedOptions = (options: any[]): any => {
  return [...(options || [])].sort((a, b) => {
    if (a.label < b.label) return -1;
    if (a.label > b.label) return 1;

    return 0;
  });
};
